import { render } from "./foot.vue?vue&type=template&id=d3ecb0fa"
import script from "./foot.vue?vue&type=script&lang=js"
export * from "./foot.vue?vue&type=script&lang=js"
script.render = render

export default script